import config from '../../config';

export default {
  url: `${config.api.baseURL}/accounts/:accountId/profiles`,
  options: {
    method: 'POST'
  },
  transformer(data) {
    return data;
  }
};
